import { observer } from "mobx-react-lite";
import * as React from "react";

// TODO sharing via share-menu functionality
// XXX check twitter "via"

// 44×44 hit area (WCAG 2.5.8 / audit), ~28px glyph; same classes as the other detail actions
const linkClass =
  "flex h-11 w-11 items-center justify-center rounded hover:bg-slate-100 dark:hover:bg-slate-800";
const iconClass = "h-7 w-7";

export const SharingButtons = observer(
  ({ url, text }: { url: string; text: string }) => {
    const encoded_url = encodeURIComponent(url);
    const encoded_text = encodeURIComponent(text);
    return (
      <>
        <a
          rel="nofollow noreferrer"
          target="_blank"
          href={`https://x.com/intent/post?text=${encoded_text}&url=${encoded_url}&;via=MediaFreedomEU`}
          title="Share on X"
          aria-label="Share on X (opens in new tab)"
          class={linkClass}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-icon="x-twitter"
            class={iconClass}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
            />
          </svg>
        </a>

        <a
          rel="nofollow noreferrer"
          target="_blank"
          href={`https://www.facebook.com/sharer/sharer.php?u=${encoded_url}&t=${encoded_text}`}
          title="Share on Facebook"
          aria-label="Share on Facebook (opens in new tab)"
          class={linkClass}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-icon="facebook-square"
            class={iconClass}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
            />
          </svg>
        </a>

        <a
          rel="nofollow"
          href={`mailto:?subject=${encoded_text}&body=${encoded_url}`}
          title="Share via Mail"
          aria-label="Share via Mail"
          class={linkClass}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-icon="envelope-square"
            class={iconClass}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
            />
          </svg>
        </a>
      </>
    );
  },
);
